<template>
  <div class="footer">
    <div class="footerBox">
      <div class="footerBoxinfo">
        <img src="@/assets/image/logo.png" alt="logo" class="footerlogo" />
        <div class="footerinfo">
          <div class="appBox">
            <div class="appitem">
              <img src="@/assets/image/footer/weibo.png" alt="" />
              <div class="patgqrBox">
                <img src="@/assets/image/footer/weiboqr.png" alt="" />
              </div>
            </div>
            <div class="appitem bli">
              <img src="@/assets/image/footer/blibli.png" alt="" />
              <div class="patgqrBox">
                <img src="@/assets/image/footer/qrbli.png" alt="" />
              </div>
            </div>
            <div class="appitem">
              <img src="@/assets/image/footer/wechat.png" alt="" />
              <div class="patgqrBox">
                <img src="@/assets/image/footer/wechatqr.png" alt="" />
              </div>
            </div>
          </div>
          <div class="text">联系我们</div>
          <div class="tel">邮箱：kaledongman@126.com</div>
          <div class="adr">地址：福建省福州市台江区世纪百联大厦11F</div>
        </div>
      </div>
      <div class="qrBox">
        <div class="text">购买遇到问题？ 请扫左侧二维码迅速解决！</div>
        <img src="@/assets/image/footer/qrimg.png" alt="qr" class="qrimg" />
      </div>
    </div>
    <div class="line"></div>
    <div class="copyright" @click="goToExternalLink">
      版权所有闽ICP备2023016110号-3
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToExternalLink() {
      window.open("https://beian.miit.gov.cn", "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-top: 43px;
  background-color: #3d3d3d;
}

.line {
  width: 1400px;
  height: 1px;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 0.1);
}

.copyright {
  font-size: 12px;
  color: #ccc;
  font-weight: 350px;
  line-height: 30px;
  cursor: pointer;
}

.footerBox {
  display: flex;
  margin: 0 auto;
  width: 1200px;
  justify-content: space-between;

  .footerBoxinfo,
  .qrBox {
    display: flex;
    align-items: center;
  }

  .footerlogo {
    width: 127px;
    height: 38px;
  }

  .footerinfo {
    margin-left: 107px;

    .appBox {
      display: flex;
      gap: 28px;

      .appitem {
        position: relative;
        width: 41px;
        height: 41px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }
        .patgqrBox {
          display: none;
          position: absolute;
          top: -125px;
          left: -40px;
          width: 90px;
          height: 90px;
          padding: 10px;
          background-color: #fff;
          border-radius: 10px;
          z-index: 10;
          img {
            width: 90px;
            height: 90px;
          }
        }
        .patgqrBox::before {
          position: absolute;
          content: "";
          left: 50%;
          transform: translateX(-50%);
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid #fff;
          bottom: -9px;
        }
      }
      .appitem:hover .patgqrBox{
        display: block;
      }
      .bli {
        width: 62px;
        height: 41px;
        .patgqrBox {
          left: -22px;
        }
      }
    }

    .text {
      margin: 16px 0;
      font-size: 18px;
      color: #fff;
      line-height: 21px;
      font-weight: 500;
    }

    .tel,
    .adr {
      font-size: 18px;
      color: #cccccc;
      font-weight: 400;
      line-height: 25px;
    }
  }

  .qrBox .text {
    max-width: 131px;
    color: #ccc;
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;
    white-space: wrap;
  }

  .qrimg {
    margin-left: 21px;
    width: 100px;
    height: 100px;
  }
}

img {
  object-fit: cover;
}
</style>